import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { apiRequest } from "../../apiServices/allApi";

const $ = require("jquery");

$.Datatable = require("datatables.net");
export default function BlockUser() {
  const [loading, setLoading] = useState(false);

  //use for pagination..
  let [limit, setLimit] = useState(20);
  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState(0);
  const [findByStatus, setFindByStatus] = useState(0);
  const [findByuserStatus, setFindByuserStatus] = useState("");

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;
    setSearchList(key);
  };

  const [user, setUser] = useState(false);

  const getUser = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/get_User/all?page=${pageNumber}&_limit=${limit}&_q=0&_stype=0&_status=block&_Userstatus=block`,
        "GET",
        null,
        headers,
      );
      setUser(res.data.admin);
      setNumberOfPages(res.data.totalPages);
    } catch (e) {
      alert(e);
    } finally {
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  const blockPlayer = async (player) => {
    const userType = player.user_type == "Block" ? "User" : "Block";
    let reason;

    if (userType === "Block") {
      const { value: text } = await Swal.fire({
        input: "textarea",
        inputLabel: "Block Reason",
        inputPlaceholder: "Type your reason here...",
        inputAttributes: {
          "aria-label": "Type your reason here",
        },
        showCancelButton: true,
      });

      reason = text;
    } else {
      const confirmUnblock = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to unblock this user?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, unblock",
        cancelButtonText: "Cancel",
      });

      if (confirmUnblock.isConfirmed) {
        reason = "unblock";
      } else {
        return; // Stop if user cancels
      }
    }

    if (reason) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest(
        `admin/block_user_api/${player._id}`,
        "POST",
        { user_type: userType, reason },
        headers,
      );

      getUser(res.data);
    } else if (userType === "Block") {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Enter Reason",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  useEffect(() => {
    getUser();
  }, [
    pageNumber,
    limit,
    searchList,
    searchType,
    findByStatus,
    findByuserStatus,
  ]);

  return loading ? (
    null
  ) : (
    user && (
      <div>
        <div className="row mt-5">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body p-4">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                  <h4 className="dashboard_heading m-0 text-danger">
                    <i className="mdi mdi-account-off text-danger mr-2"></i>{" "}
                    Block User List
                  </h4>
                </div>

                {/* searching */}
                <div className="admin-filter-bar">
                  <select
                    className="form-control"
                    style={{ maxWidth: "170px" }}
                    id="searchType"
                    name="searchtype"
                    onChange={(e) => setSearchType(e.target.value)}
                  >
                    <option value="0">Search by...</option>
                    <option value="Phone">Phone</option>
                    <option value="Name">Name</option>
                    <option value="_id">User Id</option>
                    <option value="refferal_code">Referral Id</option>
                  </select>

                  <input
                    type="text"
                    placeholder="Search..."
                    className="form-control"
                    style={{ flex: "1", minWidth: "180px" }}
                    onChange={searchHandler}
                  />

                  <select
                    className="form-control"
                    
                    id="pagelimit"
                    name="pagelimit"
                    value={limit}
                    onChange={setpageLimit}
                  >
                    <option value="10">10 / page</option>
                    <option value="20">20 / page</option>
                    <option value="50">50 / page</option>
                    <option value="100">100 / page</option>
                    <option value="500">500 / page</option>
                  </select>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th> Name</th>
                        <th> Mobile </th>
                        <th> Block by Admin / Agent </th>
                        <th> Block by</th>
                        <th> Reasion</th>
                        <th>Date</th>
                        <th> Action </th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.map((user, key) => (
                        <tr key={user._id}>
                          <td>{key + 1}</td>
                          {/* <td>
                            <span className='pl-2 text-primary'>
                              {user.Name}
                            </span>
                          </td> */}
                          <td>
                            {user.Name && (
                              <Link
                                className="btn btn-sm btn-outline-info"
                                to={`/user/view_user/${user._id}`}
                              >
                                {user.Name}
                              </Link>
                            )}
                          </td>
                          {localStorage.getItem("user") === "Admin" ||
                          localStorage.getItem("updateLegalData") === "true" ? (
                            <td className="text-success">{user.Phone}</td>
                          ) : (
                            <td className="text-success">{`${
                              "********" + user.Phone.toString().slice(-2)
                            }`}</td>
                          )}
                          <td>{user?.action_by?.user_type}</td>
                          <td className="text-success">
                            {user.action_by?.Name}
                          </td>
                          <td className="text-success">{user?.lastmsg}</td>
                          <td>
                            <td>{dateFormat(user.updatedAt).split(",")[0]}</td>
                          </td>
                          <td>
                            <button
                              type="button"
                              className={`btn  mx-1 ${
                                user.user_type == "Block"
                                  ? "btn-success"
                                  : "btn-danger"
                              }`}
                              onClick={() => {
                                blockPlayer(user);
                              }}
                            >
                              {user.user_type == "Block" ? "Unblock" : "Block"}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="mt-4">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={numberOfPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
